import { hexToRgba } from '../../../../utils/utils'

const sizes = {
    header: {
        borderRadius: '8px',
    },
    iconButton: {
        size: '2.15rem',
    },
    iconButtonLarge: {
        size: '3rem',
    },
}

export default (theme: any) => ({
    PrimaryHeaderMenu: {
        flex: 3,
        padding: '.5rem 3.4rem',
        background: theme.palette.primary.contrastText,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: `1px solid ${theme.palette.lightGrey.dark}`,
        borderRadius: `${sizes.header.borderRadius} ${sizes.header.borderRadius} 0 0`,
        borderBottom: 'none',
        minWidth: '90%',
        maxWidth: '90%',
        position: 'fixed',
        zIndex: 1300,
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%) translateY(0)',
        transition: 'transform .13s ease-out',
        opacity: '1',
        '&.ux_primary_header_menu_hidden': {
            transform: 'translateX(-50%) translateY(110%)',
            opacity: '0.2',
        },
        [theme.breakpoints.up(theme.constants.formats.breakpoint)]: {
            border: `1px solid ${theme.palette.lightGrey.dark}`,
            borderTop: 'none',
            borderRadius: `0 0 ${sizes.header.borderRadius} ${sizes.header.borderRadius}`,
            height: '100%',
            minWidth: theme.constants.formats.defaultMinWidth,
            maxWidth: `calc(${theme.constants.formats.defaultMinWidth} + 100px)`,
            position: 'static',
            transform: 'translateX(0) translateY(0)',
            opacity: '1',
            '&.ux_primary_header_menu_hidden': {
                transform: 'translateX(0) translateY(0)',
                opacity: '1',
            },
        },
        [theme.breakpoints.up('lg')]: {
            width: '100%',
            minWidth: theme.constants.formats.defaultMinWidth,
            maxWidth: theme.constants.formats.defaultMaxWidth,
        },
    },

    PrimaryHeaderMenuNavigation: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

    PrimaryHeaderMenuNavigationIconButton: {
        [theme.breakpoints.up(theme.constants.formats.breakpoint)]: {
            margin: '0 1.4rem',
            width: sizes.iconButtonLarge.size,
            height: sizes.iconButtonLarge.size,
        },
        position: 'relative',
        margin: '0 0.85rem',
        width: sizes.iconButton.size,
        height: sizes.iconButton.size,
        padding: '.43rem',
        borderRadius: '7px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& .MuiButtonBase-root': {
            width: '100%',
            height: '100%',
        },
        '& svg': {
            fill: hexToRgba(theme.palette.typography.main, 0.8),
        },
    },

    PrimaryHeaderMenuNavigationIconButtonNotif: {
        position: 'absolute',
        top: 0,
        right: 0,
        transform: 'translate(40%, -40%)',
        width: '1rem',
        height: '1rem',
        background: '#fb355d',
        borderRadius: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '.35em',
        color: '#fff',
    },

    PrimaryHeaderMenuNavigationIconButtonActive: {
        background: 'rgba(0, 0, 0, 0.04)',
        '& svg': {
            fill: theme.palette.primary.main,
        },
    },

    PrimaryHeaderMenuNavigationIconButtonSvg: {
        display: 'block',
        width: '100%',
        height: '100%',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
    },

    PrimaryHeaderMenuNavigationIconButtonSvgActive: {
        transition: 'transform .25s cubic-bezier(.20,-6,.20,6)',
        transform: 'scale(.8)',
    },

    PrimaryHeaderMenuNavigationNotificationIcon: {
        top: '-13px',
        right: '-10px',
        background: theme.palette.red.main,
        color: '#ffffff',
        [theme.breakpoints.up(theme.constants.formats.breakpoint)]: {
            top: '-17px',
        },
        fontWeight: 600,
        fontSize: '.6rem',
    },
})
